import { AnyDict } from 'interfaces'
import { PayloadAction } from 'interfaces/action'
import { createPayloadAction } from 'helpers/actionsHelpers'
import { change, focus, FieldValue } from 'redux-form'
import { FormSuccessActionPayload } from 'interfaces/form'
import { FormNameType } from 'interfaces/form'

export const SUBMIT_FORM = 'SUBMIT_FORM' as const
type SubmitForm = PayloadAction<typeof SUBMIT_FORM, { formName: FormNameType, values: AnyDict, extra?: AnyDict }>
export const submitFormActionCreator = (formName: FormNameType, values: AnyDict, extra?: AnyDict) =>
  createPayloadAction(SUBMIT_FORM, { formName, values, extra })

export const FORM_SUBMITTED_SUCCESSFULLY = 'FORM_SUBMITTED_SUCCESSFULLY' as const
export type FormSubmittedSuccessfully = PayloadAction<typeof FORM_SUBMITTED_SUCCESSFULLY, FormSuccessActionPayload>
// TODO add checking types of form value here
export const formSubmittedSuccessfullyActionCreator = (formName: FormNameType, response: any, formValues: any, extra: any): FormSubmittedSuccessfully =>
  createPayloadAction(FORM_SUBMITTED_SUCCESSFULLY, { formName, response, formValues, extra }) as any

export const FORM_SUBMIT_FAILED = 'FORM_SUBMIT_FAILED' as const
type FormSubmitFailed = PayloadAction<typeof FORM_SUBMIT_FAILED, { formName: FormNameType }>
export const formSubmitFailedActionCreator = (formName: FormNameType): FormSubmitFailed =>
  createPayloadAction(FORM_SUBMIT_FAILED, { formName })

export const FORM_FIELD_CHANGE = '@@redux-form/CHANGE' as const
export type FormFieldChange = {
  type: typeof FORM_FIELD_CHANGE
  payload: any
  meta: {
    form: FormNameType
    field: string
    touch: boolean
  }
}

export const FORM_FIELD_FOCUS = '@@redux-form/FOCUS' as const
export type FormFieldFocus = {
  type: typeof FORM_FIELD_FOCUS
  meta: {
    form: FormNameType
    field: string
  }
}

export const FORM_FIELD_UNREGISTER = '@@redux-form/UNREGISTER_FIELD' as const
type FormFieldUnregister = {
  type: typeof FORM_FIELD_UNREGISTER
  payload: FieldValue
  meta: {
    form: FormNameType
    field: string
  }
}

export const FORM_STOP_SUBMIT = '@@redux-form/STOP_SUBMIT' as const
type FormStopSubmit = {
  type: typeof FORM_STOP_SUBMIT
  payload: any
  meta: {
    form: FormNameType
  }
  error: boolean
}

export const FORM_START_ASYNC_VALIDATE = '@@redux-form/START_ASYNC_VALIDATION' as const
export type FormStartAsyncValidate = {
  type: typeof FORM_START_ASYNC_VALIDATE
  meta: {
    form: FormNameType
    field: string
  }
}

export const FORM_STOP_ASYNC_VALIDATE = '@@redux-form/STOP_ASYNC_VALIDATION' as const
export type FormStopAsyncValidate = {
  type: typeof FORM_STOP_ASYNC_VALIDATE
  meta: {
    form: FormNameType
  }
  payload?: {
    [name: string]: string
  }
  error: boolean
}

// TODO check it with our error handler
if (FORM_FIELD_CHANGE !== change('DUMMY', 'FIELD', 'DATA').type || FORM_FIELD_FOCUS !== focus('DUMMY', 'FIELD').type) {
  throw new Error('Action were changed in redux form')
}

export type FormActions =
  | SubmitForm
  | FormSubmittedSuccessfully
  | FormSubmitFailed
  | FormFieldChange
  | FormFieldUnregister
  | FormFieldFocus
  | FormStopSubmit
  | FormStartAsyncValidate
  | FormStopAsyncValidate

export default FormActions
